export const SUBMIT_FULLSCREEN_STATE = (state, fullscreenState) => {  state.isFullScreen = fullscreenState };
